.zone {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3) var(--space-4);
  align-items: center;
  padding: var(--space-5);
  border: var(--border-width) dashed var(--color-border-strong);
  border-radius: var(--radius-lg);
  background: var(--color-surface);
}

.zone[data-dragging] {
  border-color: var(--color-accent);
  border-style: solid;
  background: var(--color-accent-subtle);
}

.zone[data-invalid] {
  border-color: var(--color-danger);
}

.zone[data-disabled] {
  border-color: var(--color-border);
  background: var(--color-surface-sunken);
  color: var(--color-text-subtle);
}

.icon {
  display: inline-flex;
  color: var(--color-text-subtle);
}

.zone[data-dragging] .icon {
  color: var(--color-accent);
}

.text {
  display: flex;
  flex: 1 1 14rem;
  flex-direction: column;
  gap: var(--space-1);
}

.label {
  font-size: var(--text-md);
  font-weight: var(--weight-medium);
}

.hint {
  color: var(--color-text-muted);
  font-size: var(--text-sm);
}

.input {
  display: none;
}

.error {
  display: flex;
  flex-basis: 100%;
  gap: var(--space-1);
  align-items: center;
  color: var(--color-danger);
  font-size: var(--text-sm);
}
